import React, { useEffect, useRef } from 'react';

function Values() {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const fadeInObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                }
            });
        }, observerOptions);

        if (sectionRef.current) {
            sectionRef.current.style.opacity = '0';
            sectionRef.current.style.transform = 'translateY(30px)';
            sectionRef.current.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
            fadeInObserver.observe(sectionRef.current);
        }

        return () => fadeInObserver.disconnect();
    }, []);

    return (
        <section className="values-section" ref={sectionRef}>
            <div className="container">
                <div className="section-header-new" style={{ justifyContent: 'center' }}>
                    <h2 className="section-title-new">OUR VISION & MISSION</h2>
                </div>
                <div className="values-grid">
                    <div className="value-card">
                        <div className="value-icon">
                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <path d="M12 2L2 7l10 5 10-5-10-5z" />
                                <path d="M2 17l10 5 10-5M2 12l10 5 10-5" />
                            </svg>
                        </div>
                        <h3>OUR VISION</h3>
                        <p>
                            To become a leading signage and branding company in the UAE and beyond, recognized for
                            innovation, quality, and customer-centric solutions, while continuously evolving with modern
                            design and technology trends.
                        </p>
                    </div>

                    <div className="value-card">
                        <div className="value-icon">
                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <circle cx="12" cy="12" r="10" />
                                <path d="M12 6v6l4 2" />
                            </svg>
                        </div>
                        <h3>OUR MISSION</h3>
                        <p>
                            To deliver creative, reliable, and affordable signage and branding solutions that bring our
                            clients’ vision to life. To combine artistic creativity with advanced technology for impactful
                            brand presence.
                        </p>
                    </div>

                    <div className="value-card">
                        <div className="value-icon">
                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                <circle cx="12" cy="7" r="4" />
                            </svg>
                        </div>
                        <h3>OUR VALUES</h3>
                        <ul className="values-list" style={{ listStyle: 'none', padding: 0, textAlign: 'left', marginTop: '20px' }}>
                            <li style={{ marginBottom: '10px' }}><strong>Creativity & Innovation</strong> – We think beyond the ordinary to craft designs that captivate.</li>
                            <li style={{ marginBottom: '10px' }}><strong>Quality & Precision</strong> – Every project is executed with meticulous attention to detail.</li>
                            <li>Quality Ethics and Conduct</li>
                            <li>Respect and Dignity</li>
                            <li>Customer Satisfaction</li>
                            <li>Teamwork</li>
                            <li>Safety and Health Innovation</li>
                            <li>Corporate Responsibility</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Values;
